import { MAIN_SOCKET_API_EVENTS } from '../../constants/api/mainSocket'
import { normalizeChatGroupListSocketResult, normalizeChatGroupSocketRecord } from '../../modules/chat/normalizeChatGroupListSocketResult'
import { emitWithCallbackAck } from './socketCallbackAck'

/** List groups via mobile-canonical `chatGroups::get` (ack), same as Android/iOS. */
const FindMany = async listMetaData => {
  const raw = await emitWithCallbackAck(
    MAIN_SOCKET_API_EVENTS.LIST_CHAT_GROUPS,
    listMetaData?.toAxiosRequestParams?.() ?? {}
  )
  return normalizeChatGroupListSocketResult(raw)
}

const normalizeMutationResult = raw => {
  if (!raw || raw.error != null) {
    const message = typeof raw?.error === 'string' ? raw.error : 'Chat group mutation failed'
    return Promise.reject(new Error(message))
  }
  return normalizeChatGroupSocketRecord(raw) || raw
}

const Create = async chatGroupData => emitWithCallbackAck(
  MAIN_SOCKET_API_EVENTS.CREATE_CHAT_GROUP,
  chatGroupData
).then(normalizeMutationResult)

const Update = async (chatGroupId, chatGroupData) => emitWithCallbackAck(
  MAIN_SOCKET_API_EVENTS.UPDATE_CHAT_GROUP,
  { id: chatGroupId, ...chatGroupData }
).then(normalizeMutationResult)

const Delete = async chatGroupId => emitWithCallbackAck(
  MAIN_SOCKET_API_EVENTS.DELETE_CHAT_GROUP,
  { chatGroupId }
)

const ChatGroupSocket = {
  FindMany,
  Create,
  Update,
  Delete
}

export default ChatGroupSocket
